var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM16.6983 14.4219C17.0552 14.2554 17.4873 14.5151 17.4109 14.9014C16.9874 17.0401 15.0712 19 12 19C8.92879 19 7.01256 17.0401 6.58913 14.9014C6.51266 14.5151 6.9448 14.2554 7.30165 14.4219C8.25259 14.8656 9.96769 15.5 12 15.5C14.0323 15.5 15.7474 14.8656 16.6983 14.4219ZM16 10.5C16 11.3284 15.5523 12 15 12C14.4477 12 14 11.3284 14 10.5C14 9.67157 14.4477 9 15 9C15.5523 9 16 9.67157 16 10.5ZM9.03033 8.46967L11.0303 10.4697C11.2448 10.6842 11.309 11.0068 11.1929 11.287C11.0768 11.5673 10.8033 11.75 10.5 11.75H7.5C7.08579 11.75 6.75 11.4142 6.75 11C6.75 10.5858 7.08579 10.25 7.5 10.25H8.68934L7.96967 9.53033C7.67678 9.23744 7.67678 8.76256 7.96967 8.46967C8.26256 8.17678 8.73744 8.17678 9.03033 8.46967Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWink);
export default __webpack_public_path__ + "static/media/wink.e113b95dae43ce780e2b1a513936beca.svg";
export { ForwardRef as ReactComponent };